const communicationWidget = () => {
    const comWidget = document.querySelector('#comWidget');
    const buttonNav = document.querySelector('#buttonNav');

    if (typeof comWidget !== 'undefined' && comWidget !== null
        && typeof buttonNav !== 'undefined' && buttonNav !== null) {

        const comWidgetMainButton = comWidget.querySelector('#comWidgetMainButton');
        const comWidgetPhoneButton = comWidget.querySelector('#comWidgetPhoneButton');
        const comWidgetContactButton = comWidget.querySelector('#comWidgetContactButton');
        comWidgetMainButton.addEventListener('click', () => {
            comWidgetMainButton.classList.toggle('active');
            comWidgetPhoneButton.classList.toggle('popout');
            comWidgetContactButton.classList.toggle('popout');
        });
    }

    function checkOffset() {
        function getRectTop(el){
            const rect = el.getBoundingClientRect();
            return rect.top;
        }

        let buttonPos = 0;

        if(window.matchMedia('(min-width: 1024px)').matches) {
            buttonPos = 80 + 50; // paggin-top of .buttonNav + Button height
        } else {
            buttonPos = 40 + 50; // paggin-top of .buttonNav + Button height
        }

        if((getRectTop(comWidget) + document.body.scrollTop) + comWidget.offsetHeight
            >= (getRectTop(buttonNav) + document.body.scrollTop + buttonPos)) {
            comWidget.classList.remove('floating');
        }

        if(document.body.scrollTop + window.innerHeight
            < (getRectTop(buttonNav) + document.body.scrollTop + buttonPos + 50)) {
            comWidget.classList.add('floating');
        }
    }

    document.addEventListener('scroll', () => {
        if(document.documentElement.scrollTop > 0) {
            comWidget.classList.remove('hidden');
        } else {
            comWidget.classList.add('hidden');
        }

        //if(window.matchMedia('(max-width: 1439px)').matches) {
            checkOffset();
        //}
    });

    // document.addEventListener('DOMContentLoaded', () => {
    //     checkOffset();
    // });
}

export default communicationWidget;
